import { createReducer, on } from '@ngrx/store';
import { ProfileState, initialProfileState } from './profile.state';
import * as ProfileActions from './profile.actions';

export const profileReducer = createReducer(
  initialProfileState,

  // Load profile actions
  on(
    ProfileActions.loadProfile,
    (state): ProfileState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    ProfileActions.loadProfileSuccess,
    (state, { profile }): ProfileState => ({
      ...state,
      profile,
      loading: false,
      error: null,
    })
  ),

  on(
    ProfileActions.loadProfileFailure,
    (state, { error }): ProfileState => ({
      ...state,
      loading: false,
      error,
    })
  ),

  // Clear profile
  on(
    ProfileActions.clearProfile,
    (): ProfileState => ({
      ...initialProfileState,
    })
  )
);
